import React from 'react';
import {formatMinutes} from './record-math';
import {AllocatedScope, equipmentContribution, verdictText} from './job-math';
import './JobRecord.css';

/*
 * A finished job's readouts (SQ-597): what the time came to at each scope and
 * whether it was bid right (ActualTimeReadout.kt), and the equipment's over /
 * under tag beside a billed cost that never moves (WorkItemsView.kt).
 */

// ---- The completed job (ActualTimeReadout.kt) --------------------------------------------------------

/** SQ-559: what every readout of a finished job with no crew time says (ActualTimeReadout.kt). */
export const NO_CREW_TIME_MESSAGE = 'No crew time was recorded.';

export const ActualReadout = ({title, scope, layer}: {title: string; scope?: AllocatedScope; layer: 'item' | 'info'}) => {
  if (!scope) return null;
  // No time, no crew count, no verdict, and no title naming a time that was never recorded.
  if (scope.noCrewTime) {
    return <div className={`jb-actual jb-actual--${layer}`} role="group" aria-label={title}>{NO_CREW_TIME_MESSAGE}</div>;
  }
  const extra = equipmentContribution(scope.verdict?.equipment);
  return (
    <div className={`jb-actual jb-actual--${layer}`} role="group" aria-label={title}>
      <div className="jb-actual-title">{title}</div>
      <div className="jb-actual-row">
        <span className="jb-actual-time">{formatMinutes(scope.wallMinutes)}</span>
        <span className="er-small er-muted">Calculated off of {scope.crew} crew member{scope.crew === 1 ? '' : 's'}</span>
      </div>
      {scope.verdict && <>
        <div className="jb-actual-rule"/>
        <div className="jb-actual-row">
          <span className="jb-actual-question">Was It Bid Right?</span>
          <span className={`jb-verdict jb-verdict--${scope.verdict.kind}`}>{verdictText(scope.verdict)}</span>
        </div>
        {extra && <div className="er-small er-muted">{extra}</div>}
      </>}
    </div>
  );
};

/** EquipmentOverUnderTag: red when over, black when under; nothing when it ran as billed. */
export const OverUnderTag = ({text, over}: {text?: string; over: boolean}) =>
  text ? <span className={over ? 'jb-tag jb-tag--over' : 'jb-tag'}>{text}</span> : null;
